import { h } from './dom.js';

// No ?creation= in the URL: start a new creation from an asset, or reopen a recent one.
export async function showPicker(root, api, open) {
  const [{ assets }, { creations }] = await Promise.all([api.assets(), api.creations({ state: 'draft', limit: 20 })]);
  const names = Object.fromEntries(assets.map((a) => [a.id, a.name]));
  const status = h('div.picker-status', { role: 'alert' });

  const start = (asset) => async (e) => {
    e.currentTarget.disabled = true;
    status.textContent = '';
    try {
      const creation = await api.createCreation(asset.id);
      open(creation.id);
    } catch (err) {
      status.textContent = err.code === 'creation_limit_reached'
        ? 'You have reached the creation limit. Archive one to start another.'
        : err.message;
      e.currentTarget.disabled = false;
    }
  };

  root.replaceChildren(h('div.picker',
    h('h1', 'Blast+ Creator'),
    h('h2', 'Start from an outfit'),
    h('div.picker-assets', assets.map((a) =>
      h('button.picker-asset', { type: 'button', onclick: start(a) }, h('strong', a.name), h('span', a.asset_ref)))),
    status,
    creations.length ? h('h2', 'Continue') : null,
    h('ul.picker-creations', creations.map((c) =>
      h('li', h('a', { href: `?creation=${c.id}`, onclick: (e) => { e.preventDefault(); open(c.id); } },
        h('strong', c.title ?? names[c.asset_id] ?? c.asset_id),
        h('span', `v${c.latest_version} · ${new Date(c.updated_at).toLocaleString()}`))))),
  ));
}
